/**
 * Created by zoechodosh on 4/18/17.
 */
export const getHours = () => {
  const hrs = [];
  hrs.push({ value: '', title: 'hr' });
  for (let i = 1; i <= 12; i += 1) {
    hrs.push({ value: `${i}`, title: `${i}` });
  }
  return hrs;
};

export const minutes = [
  {
    value: '',
    title: 'mm'
  },
  {
    value: '0',
    title: '00'
  },
  {
    value: '15',
    title: '15'
  },
  {
    value: '30',
    title: '30'
  },
  {
    value: '45',
    title: '45'
  }
];

export const timezones = [
  {
    value: '',
    title: 'Guess'
  },
  {
    value: 'America/New_York',
    title: 'America/New_York'
  },
  {
    value: 'America/Los_Angeles',
    title: 'America/Los_Angeles'
  },
  {
    value: 'America/Denver',
    title: 'America/Denver'
  },
  {
    value: 'America/Phoenix',
    title: 'America/Phoenix'
  },
  {
    value: 'America/Chicago',
    title: 'America/Chicago'
  },
];



/** WEBPACK FOOTER **
 ** ./src/components/common/form/timeValues.js
 **/